export default "__VITE_ASSET__L4yiwaMT__"